
import { get } from "../lib/api";
import { ClinicFragment } from "../graphql/types-and-hooks";

export class ClinicServiceError extends Error {
  constructor(message: string, public statusCode?: number) {
    super(message);
    this.name = 'ClinicServiceError';
  }
}

export const getClinicV2 = async (groupCRM: any, userFK: string, locationId: string): Promise<ClinicFragment[]> => {
    const clinics = await get(`clinics?clinic_group_crm=${groupCRM}&user_fk=${userFK}&location_id=${locationId}`);
    return (clinics) as any[];
}
